export default class PrintSecondaryPackagingService {

    BulkDataCSVdownload(type, fromNo, toNo, prefix) {
        const data = [];
        const start = parseInt(fromNo);
        const end = parseInt(toNo);
        const year = new Date().getFullYear();
      
        if (isNaN(start) || isNaN(end) || start > end) {
          console.error("Invalid FromNo or ToNo");
          return;
        }
      
        for (let i = start; i <= end; i++) {
          const idNumber = i.toString().padStart(8, '0'); // 00001 format
          data.push(`${type}-${year}-${prefix}-${idNumber}`);
        }
      
        const csvRows = data.join("\n");
        const csvContent = "data:text/csv;charset=utf-8," + csvRows;
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `${type}-${prefix}-${fromNo}_to_${toNo}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      

}